export default "__VITE_ASSET__CbCC7vGl__"